import React from "react";
import { Text, View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { Picker } from "@react-native-picker/picker";

const ChallengeModeComponent = ({ challengeMode }) => {
  const deviceSize = useDeviceSize();
  return (
    <View
      style={{
        width:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? "100%"
            : "60%",
        flexDirection: "row",
        alignItems: "center",
        gap: 20,
      }}
    >
      <Text
        style={[
          AppFontStyle.REGULAR_ANYBODY_18,
          {
            color: AppColors.white,
            flex: 0,
            minWidth: 150,
          },
        ]}
      >
        Challenge Mode
      </Text>
      <View
        style={{
          height: 62,
          borderRadius: 12,
          borderWidth: 1,
          borderColor: AppColors.white,
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <Picker
          selectedValue={challengeMode}
          aria-disabled={true}
          style={[
            AppFontStyle.REGULAR_ANYBODY_14,
            {
              width: "100%",
              textAlign: "center",
              color: AppColors.appViolentColor_6D08C3,
              fontSize: 18,
              fontWeight: "500",
              overflow: "hidden",
              paddingVertical: 12,
              paddingHorizontal: 24,
              backgroundColor: AppColors.sidebarBackground_111827,
              borderColor: AppColors.appGrayColor_1C1C1C,
            },
          ]}
        >
          <Picker.Item
            style={[AppFontStyle.REGULAR_ANYBODY_16]}
            label="1 VS 1"
            value="1 VS 1"
          />
        </Picker>
        <View
          style={{
            width: 25,
            height: 25,
            position: "absolute",
            right: 5,
            backgroundColor: AppColors.sidebarBackground_111827,
          }}
        />
      </View>
    </View>
  );
};

export default ChallengeModeComponent;
